import React, { FunctionComponent } from 'react'

import { displayDollars } from '../../helpers/displayFormatHelper'
import { RefiTransactionsCard } from './refiTransactionsCard'
import { RefiTransactionsRow } from './refiTransactionsRow'
import { RefiTransaction } from './types'
import { NavLink } from 'react-router-dom'
import RefiTransactionsSelectedProducts from './refiTransactionsSelectedProducts'

export interface Props {
  refiTransaction?: RefiTransaction
}

const renderProducts = (products) => {
  return products.map((product, i) => {
    return (
      <RefiTransactionsCard
        key={i}
        title={
          product.type.toLowerCase() === 'vsc'
            ? 'SERVICE CONTRACT'
            : 'GAP COVERAGE'
        }
      >
        <RefiTransactionsRow field="Term" hasBottomBorder fieldsBold>
          {`${product.term} months`}
        </RefiTransactionsRow>
        <RefiTransactionsRow field="Retail price" fieldsBold>
          {displayDollars(product.retailPrice)}
        </RefiTransactionsRow>
      </RefiTransactionsCard>
    )
  })
}

export const RefiTransactionsProducts: FunctionComponent<Props> = ({
  refiTransaction,
}) => {
  const { id, selectableProducts } = refiTransaction || {
    selectableProducts: [],
  }

  const gapProducts = selectableProducts.filter(
    (product) => product.type === 'GAP'
  )
  const vscProducts = selectableProducts.filter(
    (product) => product.type === 'VSC'
  )

  const PRODUCTS_ENABLED = process.env.PRODUCTS_ENABLED === 'true'

  const productLink = (label: string) => {
    if (PRODUCTS_ENABLED) {
      return (
        <NavLink
          className="refi-transactions-products__add-product-link"
          to={`/refinance/${id}/addproduct`}
        >
          {label}
        </NavLink>
      )
    } else {
      return null
    }
  }

  return (
    <div className="refi-transactions-products">
      {selectableProducts && selectableProducts.length >= 1 ? (
        <div className="refi-transactions-products__cards">
          <div className="refi-transactions-products__header">Products</div>
          <RefiTransactionsSelectedProducts
            selectedProducts={refiTransaction?.selectedProducts}
          />
          {vscProducts.length >= 1 ? renderProducts(vscProducts) : null}
          {gapProducts.length >= 1 && vscProducts.length >= 1 ? (
            <div className="refi-transactions-products__hr" />
          ) : null}
          {gapProducts.length >= 1 ? renderProducts(gapProducts) : null}
          {productLink('Update Product')}
        </div>
      ) : (
        <div className="refi-transactions-products__empty-card">
          <div className="refi-transactions-products__header">Products</div>
          <div className="refi-transactions-products__empty-content">
            No products
            {productLink('Add Product')}
          </div>
        </div>
      )}
    </div>
  )
}

RefiTransactionsProducts.displayName = 'RefiTransactionsProducts'
